import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col sm={12}>
            © <span>2017 - </span> {new Date().getFullYear()} GesSincal <span className="d-none d-sm-inline-block"> - Creado por Javier Carrizo para <i className="mdi mdi-heart text-danger"></i> ASIJEMIN.</span>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
